import { dataModule } from '@/store/data/index';
import { websocketModule, websocketPuppeteerModule } from '@/store/ws/websocket.module';
import { configModule } from '@/store/config';

export async function postLoginDataLoad() {
  await dataModule.load();
  websocketModule.connect();
  configModule.config.plugins?.puppeteer && websocketPuppeteerModule.connect();
}
